import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "timeTable" }
const _hoisted_2 = { class: "w-95 w-md-75 w-lg-60 w-xl-55 mx-auto mb-6 text-center" }
const _hoisted_3 = { class: "subtitle alt-font" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = { class: "display-18 display-md-16 display-lg-14 mb-0" }
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = {
  key: 0,
  class: "schedule-table table bg-white"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "الايام", -1)
const _hoisted_12 = {
  key: 0,
  class: "breakTime"
}
const _hoisted_13 = { class: "day" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_w_time_table_td = _resolveComponent("w-time-table-td")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    label: _ctx.tableLabel,
    info: _ctx.tableInfo
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.model?.classRoom?.schoolName), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.model?.classRoom?.yearName), 1)
          ]),
          _createElementVNode("h2", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.model?.classRoom?.levelName) + " " + _toDisplayString(_ctx.model?.classRoom?.gradeName) + " ", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.model?.classRoom?.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.model)
              ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model?.lessonsCount, (lessonId, lessonIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: lessonIndex }, [
                          _createElementVNode("th", null, _toDisplayString(lessonId), 1),
                          (
                      lessonId == _ctx.model.breakTimeAfterClass &&
                      _ctx.model.breakTimeAfterClass != 0
                    )
                            ? (_openBlock(), _createElementBlock("th", _hoisted_12))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model?.days, (day, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(day.name), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.lessonsCount, (sessionId, lessonIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: lessonIndex }, [
                            _createVNode(_component_w_time_table_td, {
                              teacher: _ctx.teacher,
                              model: _ctx.GetSession(day, sessionId)
                            }, null, 8, ["teacher", "model"]),
                            (
                      index == 0 &&
                      sessionId == _ctx.model.breakTimeAfterClass &&
                      _ctx.model.breakTimeAfterClass != 0
                    )
                              ? (_openBlock(), _createBlock(_component_w_time_table_td, {
                                  key: 0,
                                  breakTime: "",
                                  daysCount: _ctx.model.days.length
                                }, null, 8, ["daysCount"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["label", "info"]))
}